import { Navigate, useParams } from "react-router-dom";
import { GuessAEmovi } from "../../components/GuessAEmovi";
import {
  decode,
  getDayString,
  getEmoviToGuess,
} from "../../services/utilities";
import { useMemo } from "react";
import { EmoviToGuess } from "../../interfaces/EmoviToGuess";
import dayjs from "dayjs";

export function GuessAEmoviRoute() {
  const { emovi: encodedEmovi } = useParams<{ emovi: string }>();
  const emoviToGuess: EmoviToGuess | undefined = useMemo(
    () => (encodedEmovi ? decode(encodedEmovi) : undefined),
    [encodedEmovi]
  );

  const currentString = getDayString();
  const dayString = dayjs(currentString).format("YYYY-MM-DD");
  const dailyEmovi = getEmoviToGuess(dayString);

  if (
    dailyEmovi &&
    emoviToGuess &&
    dailyEmovi.id === emoviToGuess.id &&
    dailyEmovi.emojiText === emoviToGuess.emojiText
  ) {
    return <Navigate to="/" />;
  }

  return emoviToGuess ? (
    <GuessAEmovi emoviToGuess={emoviToGuess} />
  ) : (
    <div>Oops...</div>
  );
}